module.exports = __webpack_public_path__ + "img/d6504.7408539c.png";